import React from "react";
import PropTypes from "prop-types";
import { molecularProfileFields } from "../helpers";
import Expander from "../../../../../../components/Expander";
import EvidenceColumn from "./EvidenceColumn";
import VariantColumn from "./VariantColumn";
import MolecularProfileColumn from "./MolecularProfileColumn";

const MolecularProfilesTable = ({ molecularProfiles }) => {
  if (molecularProfiles && molecularProfiles.length > 0) {
    const fields = molecularProfileFields;
    return (
      <div className="varsome-inner-container">
        <h5>Molecular Profiles</h5>
        <table className="varsome-table">
          <thead>
            <tr>
              {fields.map(({ title, key, width }) => {
                return (
                  <th
                    className="tw-overflow-wrap-break-word"
                    key={key}
                    width={width}
                  >
                    {title}
                  </th>
                );
              })}
            </tr>
          </thead>
          <Expander showMore="10" component="tbody" columns={fields.length}>
            {molecularProfiles.map((item) => {
              const {
                molecular_profile: molecularProfile,
                molecular_profile_civic_id: id,
              } = item;
              return (
                <tr key={`row${id}`}>
                  <td key={`molecular-profile-${id}`}>
                    <MolecularProfileColumn
                      molecularProfile={molecularProfile.name}
                      molecularId={id}
                      summary={molecularProfile.summary}
                    />
                  </td>
                  <td key={`evidences-ids-${id}`}>
                    <EvidenceColumn
                      evidenceIds={molecularProfile.evidence_item_ids}
                    />
                  </td>
                  <td key={`variant-${id}`}>
                    <VariantColumn variant={molecularProfile.variant} />
                  </td>
                </tr>
              );
            })}
          </Expander>
        </table>
      </div>
    );
  }

  return null;
};

MolecularProfilesTable.propTypes = {
  molecularProfiles: PropTypes.arrayOf(
    PropTypes.shape({
      molecular_profile: PropTypes.shape({}),
      molecular_profile_civic_id: PropTypes.number,
    })
  ),
};

MolecularProfilesTable.defaultProps = {
  molecularProfiles: [],
};

export default MolecularProfilesTable;
